import React, { useState } from "react";

const OptionDropDown = ({ options, borderState, index }) => {
    const [dropdownOpen, setDropDownOpen] = useState(false);

    const parseCamelCase = (text) => {
        return text.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1");
    };

    return (
        <React.Fragment>
            <div className="flex flex-col justify-start items-start">
                <button
                    className={`flex flex-shrink-0 justify-center items-center w-[42px] h-[42px] text-slate-700 bg-white rounded-lg shadow border ${borderState} hover:bg-gray-100 cursor-pointer`}
                    onClick={() => {setDropDownOpen(prev => !prev);}}
                >
                    <img className="w-[24px] h-[24px]" src="/icons/options.svg" alt="icon"/>
                </button>
                {
                    dropdownOpen && (
                        <div
                            className="fixed inset-0 h-full w-full z-10"
                            x-show="dropdownOpen"
                            onClick={() => {setDropDownOpen(prev => !prev);}}
                        />
                    )
                }
                {
                    dropdownOpen && (
                        <div className="absolute columns-1 mt-[46px] py-2 w-64 bg-white rounded-md shadow-xl z-20 ring-1 ring-black/10">
                            {
                                (options?.length > 0) && (
                                    options.map(
                                        (option, i) => {
                                            return (
                                                <label key={i} className="flex gap-x-2 py-1 px-4 font-semibold text-xs leading-tight text-gray-700">
                                                    <input
                                                        className="flex justify-center items-center p-0.5 bg-gray-50 rounded border border-blue-600 cursor-pointer"
                                                        type="checkbox"
                                                        checked={option.value}
                                                        onChange={(e) => { option.onChange({ label: option.label, value: e.target.checked, options: options });}}
                                                    />
                                                    <div className="capitalize">{parseCamelCase(option.label)}</div>
                                                    <span className="relative has-tooltip">
                                                        <img className="w-3.5 h-3.5" src={"/icons/info-circle.svg"} alt="icon"/>
                                                        <span
                                                            className={
                                                                "tooltip rounded shadow-lg whitespace-normal break-normal min-w-[10vw] max-w-[25vw] [@media(max-width:1200px)]:max-w-[40vw] [@media(min-width:1600px)]:max-w-[25vw] w-max bottom-[90%]    "
                                                                + (window.screen.availWidth > 1200 ? (index === 0 || index === 2 || index === 4 ? "left-[50%] " : "right-[50%] ") : ("[@media(max-width:1200px)]:right-[50%]  "))
                                                            }
                                                        >
                                                            {option.description}
                                                        </span>
                                                    </span>
                                                </label>
                                            )
                                        }
                                    )
                                )
                            }
                        </div>
                    )
                }
            </div>
        </React.Fragment>
    );
};

export default OptionDropDown;